module.exports = __webpack_public_path__ + "static/media/icon_RMB.dc8a051b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon_RMB.png
// module id = 1768
// module chunks = 0 1